import { ORGANIZATIONS, USER_ROLES } from 'cpool-constants';
import { z } from 'zod';

import { schemaUserCommon } from './userCommon';

export const schemaAccountantManager = z
    .object({ organization: z.nativeEnum(ORGANIZATIONS), role: z.literal(USER_ROLES.accountant_manager) })
    .merge(schemaUserCommon);
